import { render, staticRenderFns } from "./subtractParamsModal.vue?vue&type=template&id=63b4b223&scoped=true&"
import script from "./subtractParamsModal.vue?vue&type=script&lang=js&"
export * from "./subtractParamsModal.vue?vue&type=script&lang=js&"
import style0 from "./subtractParamsModal.vue?vue&type=style&index=0&id=63b4b223&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b4b223",
  null
  
)

export default component.exports